import parseISO from 'date-fns/parseISO'
import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'
import addHours from 'date-fns/addHours'
import formatDate from "@utils/format-date";
import subDays from 'date-fns/subDays'
import router from "@router";
import addMinutes from 'date-fns/addMinutes'

export function eventIsDealerOnly({ canRegisterGroup } = {}) {
  return canRegisterGroup === 6
}


export function eventIsStart(startDate) {
  return startDate
    ? !isBefore(new Date(), parseISO(startDate))
    : true;
}

export function eventIsEnd(endDate) {
  return endDate
    ? isAfter(new Date(), parseISO(endDate))
    : false;
}

// export function eventIsBeforeEndDay(endDate) {
//   if(endDate) {
//     const beforeTwoDay = subDays(parseISO(endDate), 2)
//     console.log('前兩天' + beforeTwoDay, parseISO(endDate))
//     return beforeTwoDay
//     ? isAfter(new Date(), beforeTwoDay)
//       : true;
//   } else {
//     return true
//   }
// }

// 一小時內
export function eventIsNearStart(startDate) {
  if (startDate) {
    const advanceOneHours = addHours(parseISO(startDate), -1);

    return advanceOneHours
      ? isAfter(new Date(), advanceOneHours)
      : true;
  } else {
    return true
  }
}

export function eventBeforeIsNearStart(startDate) {
  if (startDate) {
    const advanceOneHours = addHours(parseISO(startDate), -5);

    return advanceOneHours
      ? isBefore(new Date(), advanceOneHours)
      : true;
  } else {
    return true
  }
}

// 前五小時
export function eventIsComming(startDate) {
  if (startDate) {
    const advanceOneHours = addHours(parseISO(startDate), -5);

    return advanceOneHours
      ? isAfter(new Date(), advanceOneHours) && !eventIsStart(startDate)
      : true;
  } else {
    return true
  }
}


export function eventIsComminMinute(startDate) {
  if (startDate) {
    const advanceMinute = addMinutes(parseISO(startDate), -5);

    return advanceMinute
      ? isAfter(new Date(), advanceMinute) && !eventIsStart(startDate)
      : true;
  } else {
    return true
  }
}

export function eventIsCanRegister({ registrationStartDate, registrationEndDate } = {}) {
  return eventIsStart(registrationStartDate)
    && !eventIsEnd(registrationEndDate)
}

export function eventTimeRange({ startTime = '', endTime = '' } = {}) {
  return [
    startTime,
    endTime
  ].join('~')
}

export function eventRegistrationDateRange({ registrationStartDate = '', registrationEndDate = '' } = {}) {
  const startDate = registrationStartDate
    ? formatDate(parseISO(registrationStartDate), 'yyyy/MM/dd')
    : '即日起';
  const endDate = registrationEndDate
    ? formatDate(parseISO(registrationEndDate), 'yyyy/MM/dd')
    : '不限時間';

  return [
    startDate,
    endDate
  ].join('~')
}

export function eventPublishDate({ linkOpeningTime, dateTime }) {
  const date = linkOpeningTime || dateTime;

  return date
    ? formatDate(date, 'yyyy/MM/dd')
    : '-----'
}

export function eventLocationTitle(type, categoryTitle) {
  const locationTitleMap = {
    physical: `${categoryTitle || '活動'}地點`,
    online: '線上直播'
  };

  return locationTitleMap[type] || '活動地點'
}

export function eventSessionTimeTitle(type, categoryTitle) {

  const eventSessionTimeTitle = {
    physical: `${categoryTitle || '活動'}時間`,
    online: '線上直播時間'
  };

  return eventSessionTimeTitle[type] || '活動時間'
}

export function eventLocationAddress({ city, district, address } = {}) {
  return `${city || ''}${district || ''}${address || ''}`
}

export function eventLocationContent({
  eventType,
  locationName,
  city,
  district,
  address,
  regStatus,
  startTime,
  endTime,
  date,
  alias,
  seriesNum,
  uuid,
  linkOpeningTime,
  shortLink
} = {}) {
  switch (eventType) {
    case 'online':
      if (regStatus === 'CONFIRMED') {
        const onlineStatusItem = eventOnlineStatusItem({
          date,
          startTime,
          endTime,
          alias,
          seriesNum,
          uuid,
          linkOpeningTime,
          shortLink
        });
        // const link = onlineStatusItem.to
        //   ? `${ window.location.origin }${
        //     router.resolve(onlineStatusItem.to).href
        //   }`
        //   : '';
        const link = onlineStatusItem.to ?? ''

        return `<a
                  href="${link}"
                  class="${onlineStatusItem.class} baseButton isStylePrimary isTextUnderline"
                  style="white-space: normal;text-align: left;line-break: anywhere;"
                >
                  ${link}
                </a>`
      } else if (regStatus === 'CANCELED') {
        return '報名已取消';
      }
      else {
        return '直播網址將在通過報名後查看';
      }
    case 'physical':
    default:
      if (locationName || city || district || address) {
        const fullAddress = eventLocationAddress({ city, district, address });
        const formatAddress = fullAddress
          ? locationName
            ? `(${fullAddress})`
            : fullAddress
          : '';

        return formatAddress
          ? `<a
              target="_blank" 
              href="https://www.google.com.tw/maps/search/${fullAddress}"
            >   
              ${locationName || ''}${formatAddress}<i class="fal fa-external-link ml-2"></i>
            </a>`
          : locationName
      } else {
        return '----'
      }
  }
}

export function eventOnlineStatusItem({ date, startTime, endTime, alias, seriesNum, uuid, linkOpeningTime, shortLink } = {}) {
  const startDate = `${date} ${startTime}`;
  const endDate = `${date} ${endTime}`;

  const to = shortLink ?? `${window.location.origin}${router.resolve({
    name: 'member-event-item-live',
    params: {
      eventAlias: alias,
      eventSeriesNum: seriesNum,
      sessionUuid: uuid,
    }
  }).href
    }`;
  const statusItem = () => {
    if (!eventIsStart(linkOpeningTime)) {
      return {
        mode: 'NOT_OPEN',
        title: '尚未開放',
        sessionTitle: `直播開放時間：${formatDate(parseISO(linkOpeningTime), 'yyyy/MM/dd HH:mm')}`,
        to,
        class: ''
      }
    } else if (eventIsComming(startDate)) {
      return {
        mode: 'IS_COMMING',
        title: '即將直播',
        sessionTitle: '直播即將開始，點此前往觀看',
        to,
        class: 'color-primary',
        class2: 'isStylePrimary'
      }
    } else if (!eventIsStart(startDate) && !eventIsStart(endDate)) {
      return {
        mode: 'NOT_START',
        title: '尚未開始',
        sessionTitle: '直播時間尚未開始',
        to,
        class: '',
        class2: 'isStyleDark'
      }
    } else if (eventIsStart(startDate) && !eventIsStart(endDate)) {
      return {
        mode: 'IS_LIVE',
        title: '直播中',
        sessionTitle: '正在直播中，點此前往觀看',
        to,
        class: 'color-danger',
        class2: 'isStyleDanger'
      }
    } else {
      return {
        mode: 'IS_END',
        title: '已結束',
        sessionTitle: '直播已結束',
        to,
        class: 'color-success',
        class2: 'isStyleDark'
      }
    }
  };

  return {
    mode: statusItem().mode || '',
    title: statusItem().title || '',
    sessionTitle: statusItem().sessionTitle || '',
    to: statusItem().to || '',
    class: statusItem().class || '',
    class2: statusItem().class2 || '',
  }
}
